import { FamilyGroup } from '../../../models/family-group.entity';
import { MajorGroup, } from '../../../models/major-group.entity';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3 } from '../../http';


const dishLabelApi = {

    // *********************
    //  菜品报表主类别标签
    // *********************
    // TODO
    /**
     * 获取报表主类别标签
     */
    async getDishReportLabel(rbpStringId?: string): Promise<MajorGroup[]> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/settings/major_group/${sid}`)
    },
    /**
     * 创建报表主类别标签
     */
    async postDishReportLabel(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/settings/major_group/${getRBPStringId()}`, params)
    },
    /**
     * 编辑报表主类别标签
     */
    async patchDishReportLabel(params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/settings/major_group/${getRBPStringId()}`, params)
    },
    /**
     * 删除报表主类别标签
     */
    async delDishReportLabel(id: string): Promise<any> {
        return await http.delete(`${BASE_URL_3}/settings/major_group/${id}/${getRBPStringId()}`)
    },
    /**
     * 批量删除报表主类别标签+
     */
    async delBatchDishReportLabel(ids: number[]): Promise<any> {
        return await http.delete(`${BASE_URL_3}/settings/major_group/${getRBPStringId()}`, {
            data: ids
        })
    },
    // *********************
    // 菜品岗位类别标签
    // *********************
    /**
     * 获取菜品岗位类别标签
     */
    async getDishPostLabel(rbpStringId?: string): Promise<FamilyGroup[]> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/settings/mergetypes/${sid}`)
    },
    /**
     * 创建菜品岗位类别标签
     */
    async postDishPostLabel(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/settings/mergetypes/${getRBPStringId()}`, params)
    },
    /**
     * 编辑菜品岗位类别标签
     */
    async patchDishPostLabel(params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/settings/mergetypes/${getRBPStringId()}`, params)
    },
    /**
     * 删除菜品岗位类别标签
     */
    async delDishPostLabel(params: { family_group_id: number[] }): Promise<any> {
        return await http.delete(`${BASE_URL_3}/settings/mergetypes/${getRBPStringId()}`, {
            data: params
        })
    },
}
export default dishLabelApi;
